import TypistHub from '@/views/TypistHub.vue';
import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('hub'),
    component: TypistHub,
  },
];
